export default __webpack_public_path__ + "static/17.Sunshine Kid-38c7c7a6b9f0ff1cf3d0a1ccc8f78c09.png";